import type { GoalModalProps } from '@/modules/actionPlan/pages/components/GoalModal/GoalModal.types'

import { Modal } from '@/components/Modal/Modal'

import classes from './GoalModal.module.css'

export function GoalModal({ children, onClose, opened }: GoalModalProps) {
  return (
    <Modal
      centered
      classNames={classes}
      onClose={onClose}
      opened={opened}
      withCloseButton={false}
    >
      {children}
    </Modal>
  )
}
